<template>
  <div>
    <div class="container">
      <b-row>
        <b-col>
          <h2 class="NewsTitle">
            News
          </h2>
        </b-col>
      </b-row>
      <News :sidebar='sidebar' :config="config"/>
    </div>
    <div>
      <Footer :white="white" :config="config"/>
    </div>
  </div>
</template>

<script>
import News from '@/components/news.vue'
import Footer from "@/components/footer.vue";

export default {
  name: "posts",
  props: ["config"],
  components: {
   News, Footer
  },
  data(){
    return{
      white:false,
    }
  }
};
</script>
<style scoped>
h2.NewsTitle {
  font-weight: 700;
  margin-top: 50px
}
</style>
